import { combineReducers } from 'redux';
import commonReducers from '../../shared/store/common/reducers';
import departmentsReducers from './departments/reducers';
import departmentUsersReducers from "./department-users/reducers";
import rolesReducers from "./roles/reducers";
import optionsReducers from '../../subscriber-app/store/options/reducers';
import departmentSettingsReducers from "../../subscriber-app/store/department-settings/reducers";
import formsReducers from "../../subscriber-app/store/forms/reducers";
import notificationReducers from "../../subscriber-app/store/notifications/reducers";
import tagReducers from "../../subscriber-app/store/tags/reducers";
import tPsReducers from "../../subscriber-app/store/training-programs/reducers";
import usersReducers from "../../subscriber-app/store/users/reducers";
import phoneReducers from "../../subscriber-app/store/phones/reducers";
import addressReducers from "../../subscriber-app/store/addresses/reducers";
import myDepartmentReducers from "../../subscriber-app/store/my-department/reducers";
import myProfileReducers from "../../subscriber-app/store/my-profile/reducers";
import taskGroupReducers from "../../subscriber-app/store/task-groups/reducers";
import taskReducers from "../../subscriber-app/store/tasks/reducers";
import subDepartmentsReducers from "../../subscriber-app/store/sub-departments/reducers";
import taskConfigReducers from "./tasks-config/reducers";

const rootReducers = combineReducers({
  addresses: addressReducers,
  common: commonReducers,
  departments: departmentsReducers,
  departmentUsers: departmentUsersReducers,
  roles: rolesReducers,
  options: optionsReducers,
  departmentSettings: departmentSettingsReducers,
  forms: formsReducers,
  myDepartment: myDepartmentReducers,
  myProfile: myProfileReducers,
  notifications: notificationReducers,
  phones: phoneReducers,
  tags: tagReducers,
  trainingPrograms: tPsReducers,
  taskGroups: taskGroupReducers,
  taskConfig: taskConfigReducers,
  tasks: taskReducers,
  users: usersReducers,
  subDepartments: subDepartmentsReducers
});

export default rootReducers;
